(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-cyber-menu-link]');
  if (!link) return;
  const details = link.closest('header-drawer').querySelector('#Details-menu-drawer-container');
  if (details.open) details.querySelector('summary').click();
});
  } catch(e) { console.error(e); }
})();

})();
